import React from "react";
import { adobeAnalytics } from "@ey/voltron-analytics";
import CreateReviewCopy from "./createreviewcopy";

const CRPWrapper = (props) => {
    const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

    return (
        <CreateReviewCopy {...props} trackEvent={trackEvent}/>
    );
}
export default CRPWrapper;